import axios from 'axios';

export const getDefaultExportColumnsByType = (extractType) => {
  const getColumns = axios.get(`/seller/customextracts/defaultColumnsByType?extractType=${extractType}`).then((response) => {
    const { data } = response;
    return data;
  });
  return getColumns;
};

export const getExportColumnsByExtractId = (extractId) => {
  const getColumns = axios.get(`/seller/customextracts/columns?extractId=${extractId}`).then((response) => {
    const { data } = response;
    return data;
  });
  return getColumns;
};

export const getSavedExportFormats = () => {
  const getSavedExports = axios.get('/seller/customextracts').then((response) => {
    const { data } = response;
    return data;
  });
  return getSavedExports;
};

export const createExportFormat = (includedFields, exportType, exportName) => {
  const formatRequest = {
    includedFields,
    extractType: exportType,
    name: exportName,
  };
  const createNewFormat = axios.post('/seller/customextracts/addCustomExtract', formatRequest).then((response) => {
    const { data } = response;
    return data;
  });
  return createNewFormat;
};

export const editExportFormat = (exportId, includedFields, exportName) => {
  const updateFormatRequest = {
    extractId: exportId,
    includedFields,
    name: exportName,
  };
  const updateFormat = axios.put('/seller/customextracts/editCustomExtract', updateFormatRequest).then((response) => {
    const { data } = response;
    return data;
  });
  return updateFormat;
};

export const deleteExportFormat = (exportId) => {
  const deleteFormat = axios.delete(`/seller/customextracts/${exportId}`).then((response) => response);
  return deleteFormat;
};
